export default {
      id: "ic_top_scroll-usage",
      viewBox: "0 0 50 50",
      url: "../dist/images/" + "sprite.svg#ic_top_scroll-usage",
      toString: function () {
        return this.url;
      }
    }